import React, { useEffect, useState } from 'react'

const useIsMobile = (breakpoint = 768) => {
  const [width, setWidth] = useState(window.innerWidth)

  function handleWindowSizeChange() {
    setWidth(window.innerWidth)
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  return [width <= breakpoint]
}

export default useIsMobile



// WEBPACK FOOTER //
// ./src/hooks/useBreakpoint.js